var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useEffect, useMemo, useRef } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router';
import { useUnmountRef } from '@/hooks/lifecycle/useUnmountRef';
import { CaseListPage } from '@/pages/case/CaseList/CaseListPage';
import { useCaseListFetchCategory } from '@/pages/case/CaseList/useCaseListFetchCategory';
import { useCaseListFetchEvent } from '@/pages/case/CaseList/useCaseListFetchEvent';
import { useCaseListFetchList } from '@/pages/case/CaseList/useCaseListFetchList';
import { parseQuery, parsedQueryToString, } from '@/utils/libs/query-string/parse';
/**
 * 選定支援事例一覧ページ（データ取得, 認証以外のアクセス制限）
 */
export const CaseList = (props) => {
    const { articleLinkListItems } = props;
    const dispatch = useDispatch();
    const unmountRef = useUnmountRef();
    const location = useLocation();
    const { categoryValue: selectingCategoryValue, priceValues: selectingPriceValues, refValue: queryParamsRefValue, } = useMemo(() => {
        const queryParams = parseQuery(location.search);
        const categoryQueryString = parsedQueryToString(queryParams.category) || undefined;
        const categoryValue = parseInt(categoryQueryString || '', 10) || undefined;
        const priceQueryString = parsedQueryToString(queryParams.price) || undefined;
        const priceValues = (priceQueryString || '')
            .split(',')
            .map((price) => parseInt(price, 10))
            .filter((price) => !!price);
        return {
            categoryValue,
            priceValues,
            refValue: { category: categoryQueryString, price: priceQueryString },
        };
    }, [location.search]);
    const queryParamsRef = useRef();
    // query の更新で hooks 内の処理が動かなように ref にしておく
    queryParamsRef.current = queryParamsRefValue;
    // カテゴリー 取得処理
    const { caseCategoriesData, fetchCaseCategory, hasInitialCategoriesData, isLoadingCaseCategories, } = useCaseListFetchCategory({
        dispatch,
        unmountRef,
    });
    // 一覧 取得処理
    const { caseListPageData, changeCaseListPageData, fetchCaseListPageData, getReplaceUrl, hasInitialCaseListPageData, isLoadingCaseList, } = useCaseListFetchList({
        dispatch,
        locationState: location.state,
        pathname: location.pathname,
        queryParamsRef,
        unmountRef,
    });
    // ユーザーイベント関連の処理（絞り込み等）
    const { onChangeNextPage, onChangeSelectingCategory, onChangeSelectingPrices, } = useCaseListFetchEvent({
        changeCaseListPageData,
        fetchCaseListPageData,
        getReplaceUrl,
    });
    // データ取得: カテゴリー
    useEffect(() => {
        if (hasInitialCategoriesData) {
            return;
        }
        ;
        (() => __awaiter(void 0, void 0, void 0, function* () {
            yield fetchCaseCategory();
        }))();
    }, [fetchCaseCategory, hasInitialCategoriesData]);
    // データ取得: 一覧
    useEffect(() => {
        if (hasInitialCaseListPageData) {
            return;
        }
        const { param, url } = getReplaceUrl();
        (() => __awaiter(void 0, void 0, void 0, function* () {
            yield fetchCaseListPageData(url, param, 1);
        }))();
    }, [fetchCaseListPageData, getReplaceUrl, hasInitialCaseListPageData]);
    return (_jsx(CaseListPage, { articleLinkListItems: articleLinkListItems, caseCategories: caseCategoriesData, caseListPageData: caseListPageData, isLoadingCaseCategories: isLoadingCaseCategories, isLoadingCaseList: isLoadingCaseList, location: location, onChangeNextPage: onChangeNextPage, onChangeSelectingCategory: onChangeSelectingCategory, onChangeSelectingPrices: onChangeSelectingPrices, selectingCategoryValue: selectingCategoryValue, selectingPriceValues: selectingPriceValues }));
};
